var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_vm._l((_vm.tabs),function(tab){return _c('div',{key:'tab-' + tab.id,staticClass:"tab",class:{
            [`${_vm.module}-tab-active`]: tab.active,
            disabled: _vm.loading,
            'tab-active': tab.active,
            [`tab-${_vm.size}`]: true,
        },attrs:{"id":`btn-talk-${tab.id}`},on:{"click":function($event){return _vm.onClickTabHandler(tab)}}},[_c('span',{staticClass:"tab-title"},[_vm._v("\n            "+_vm._s(tab.title)+"\n            "),(_vm.showBadge(tab) && _vm.badgeCount)?_c('b-badge',{staticClass:"ml-2",attrs:{"pill":"","variant":"danger"}},[_vm._v(_vm._s(_vm.badgeCount))]):_vm._e()],1)])}),_c('span',{ref:"underline",staticClass:"underline"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }